import { Args, RequestContext, Query, InitialArgs } from '../types/request-context';
import { ClientsideLogger } from '../logger/logger';

export const mockRequestContext: RequestContext = {
    customerID: 'XXXXXXXXXXXXXXXX',
    isInternal: '1',
    requestID: '3BG2QKT044ZH8E680Q1X',
    domain: 'Fogg',
    marketplaceID: 'ART4WZ8MWBX2Y',
    sessionID: '258-0086353-3654954',
    customerIPAddress: '54.240.197.239',
    locale: 'en_US',
    osLocale: 'en-US,en;q=0.9',
    currentTerritory: 'IE',
    recordTerritory: 'IE',
    originalURI: '/',
    path: '/gp/video/storefront',
    weblabOverrides: {},
    parameters: {
        mock: { __type: Query.StringValue, value: 'mock' }
    },
    userAgent:
        'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/68.0.3440.106 Safari/537.36',
    trafficPolicies: 'RM-INT',
    appName: 'mock',
    geoToken: 'mock',
    contingencies: undefined
};

export const mockInitArgs: InitialArgs = {
    context: mockRequestContext,
};

export const mockArgs: Args = {
    context: mockRequestContext,
    logger: new ClientsideLogger('mock')
};
